import React from "react";
import { Download } from "lucide-react";
import Reveal from "./Reveal";
import { hero, BROCHURE_URL } from "../mock";

const renderBold = (text) => {
  const parts = text.split(/\*\*(.*?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <strong key={i} className="font-semibold text-neg-navy">
        {part}
      </strong>
    ) : (
      <span key={i}>{part}</span>
    )
  );
};

const Hero = () => {
  return (
    <section id="about" className="relative bg-neg-cream pt-28 lg:pt-36 pb-16 lg:pb-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 border border-neg-gold/40 translate-x-4 translate-y-4 -z-0" />
              <img
                src={hero.image}
                alt="North East Grove building"
                className="relative z-10 w-full h-[420px] lg:h-[520px] object-cover shadow-2xl shadow-black/20"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              <p className="text-neg-gold text-xs tracking-[0.32em] uppercase mb-5">
                {hero.eyebrow}
              </p>
              <h1 className="font-display text-neg-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.08]">
                {hero.title.map((line, i) => (
                  <span key={i} className="block">
                    {line}
                  </span>
                ))}
              </h1>
              <div className="mt-7 space-y-4 text-neg-navy/70 text-[17px] leading-relaxed max-w-xl">
                {hero.paragraphs.map((p, i) => (
                  <p key={i}>{renderBold(p)}</p>
                ))}
              </div>
              <a
                href={BROCHURE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-9 inline-flex items-center gap-3 bg-neg-green text-neg-cream px-8 py-4 text-sm tracking-widest uppercase hover:bg-neg-green-dark transition-all duration-300"
              >
                <Download size={16} className="transition-transform duration-300 group-hover:translate-y-0.5" />
                Download Brochure
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Hero;
